import { render, staticRenderFns } from "./BlogCategoryForm.vue?vue&type=template&id=2eefc606&"
import script from "./BlogCategoryForm.vue?vue&type=script&lang=js&"
export * from "./BlogCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports